import { render, staticRenderFns } from "./CytomineTerm.vue?vue&type=template&id=f0055be8&scoped=true&"
import script from "./CytomineTerm.vue?vue&type=script&lang=js&"
export * from "./CytomineTerm.vue?vue&type=script&lang=js&"
import style0 from "./CytomineTerm.vue?vue&type=style&index=0&id=f0055be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0055be8",
  null
  
)

export default component.exports